const featuredLinksData = {
	communityFeatured: {
		title: 'Resources',
		links: [
			{ link: 'Freelancers Union', href: 'https://freelancersunion.org/advocacy/' },
			{ link: 'Freelance Tax filing', href: 'https://www.taxact.com/taxes-online' },
			{ link: 'Banking for Freelancers', href: 'https://www.bankonloop.com/freelancers' },
			{ link: 'LLC Formation', href: 'https://www.zenbusiness.com/' },
			{ link: 'IRS Self-Employed Tax Center', href: 'https://www.irs.gov/businesses/small-businesses-self-employed' },
		],
	},
	productsFeatured: {
		title: 'Seasonal Harrods Gift Baskets',
		links: [
			{ link: 'Grosvenor Christmas', href: 'https://www.harrods.com/en-us/p/harrods-the-grosvenor-christmas-hamper-000000000000272240' },
			{ link: 'Gourmet Hamper', href: 'https://www.harrods.com/en-us/p/harrods-the-gourmet-hamper-000000000006934384' },
			{
				link: 'Family Sharing',
				href: 'https://www.harrods.com/en-us/p/harrods-the-family-sharing-hamper-000000000006934375',
			},
			{ link: 'Halal Hamper', href: 'https://www.harrods.com/en-us/p/harrods-the-halal-hamper-000000000007622648' },
			{
				link: 'Cheese Master',
				href: 'https://www.harrods.com/en-us/p/harrods-the-cheese-master-hamper-000000000007797536',
			},		
		],
	},
};

export default featuredLinksData;
